import { render, staticRenderFns } from "./EditorClose.vue?vue&type=template&id=4bfe2a13&"
import script from "./EditorClose.vue?vue&type=script&lang=js&"
export * from "./EditorClose.vue?vue&type=script&lang=js&"
import style0 from "./EditorClose.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports